<template>
  <div>
    <v-card flat outlined min-height="30">
      <MarketPlan :isEdit="true" />
    </v-card>
  </div>
</template>

<script>
import MarketPlan from "../../components/MarketPlan.vue";
export default {
  components: {
    MarketPlan
  },
};
</script>